import React from "react";
import { StaffFrame, ProgrammerView, PageHead } from "./DashboardShared";
import { useShowToast } from "../components/Notify";

export default function ProgrammerPage() {
  const showToast = useShowToast();

  return (
    <StaffFrame>
      <div className="page">
        <PageHead title="Horaires & Trajets" sub="Créez, modifiez et gérez les trajets" />
        <ProgrammerView showToast={showToast} />
      </div>
    </StaffFrame>
  );
}
